<div class="production-db-content" dir="{{languageDir}}">
  <div class="content-top-box">
    <ul class="breadcrumb">
      <ul class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
          <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
            (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}</a>
        </li>
      </ul>
    </ul>
    <div class="title-row-flex-both-end">
      <h1 class="main-title">{{langObj ? langObj?.DowntimeParetoDashBoard : ('Downtime Pareto DashBoard' | translate)}}
      </h1>
    </div>
  </div>
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
  <form [formGroup]="ParetoAnalysisForm">
    <div class="content-top-row content-top-row-order-processing">
      <!-- GROUP -->
      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <!-- <mat-label>Status</mat-label> -->
        <mat-select formControlName="UserGroup1" (selectionChange)="onChangeGroup($event)"
          placeholder="{{langObj ? langObj?.Group : ('Group' | translate)}}" panelClass="testClass" name="Status">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'EG_Desc'" [array]="GroupList"
            (filteredReturn)="filteredGroups = $event"></mat-select-filter>
          <mat-option *ngFor="let group of filteredGroups" [value]="group.EG_Id">
            {{group.EG_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-select formControlName="UserPlant1" (selectionChange)="onChangePlant($event)"
          placeholder="{{langObj ? langObj?.Plant : ('Plant' | translate)}}" panelClass="testClass" name="Status">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'PT_Desc'" [array]="PlantList1"
            (filteredReturn)="filteredPlants = $event"></mat-select-filter>
          <mat-option *ngFor="let plant of filteredPlants" [value]="plant.PT_Id">
            {{plant.PT_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-select formControlName="line" (selectionChange)="onChangeLine($event)"
          placeholder="{{langObj ? langObj?.Line : ('Line' | translate)}}" panelClass="testClass" name="line">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'PL_Desc'" [array]="lineList"
            (filteredReturn)="filteredLines = $event"></mat-select-filter>
          <mat-option *ngFor="let line of filteredLines" [value]="line.PL_Id">
            {{line.PL_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-select formControlName="unit" placeholder="{{langObj ? langObj?.Unit : ('Unit' | translate)}}"
          panelClass="testClass" name="unit" (selectionChange)="onSubmit()">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'PU_Desc'" [array]="unitList"
            (filteredReturn)="filteredUnits = $event"></mat-select-filter>
          <mat-option *ngFor="let unit of filteredUnits" [value]="unit.PU_Id">
            {{unit.PU_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Dropdown -->
    <div class="content-top-row content-top-row-order-processing">
      <div class="inputField">
        <nz-date-picker class="calender-input" id="startPicker" formControlName="dateStart" nzFormat="dd/MM/yyyy HH:mm"
          [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
        <span class="floating-text">{{langObj ? langObj?.StartDate : ('Start Date' | translate)}}</span>
      </div>
      <div class="inputField">
        <nz-date-picker class="calender-input" id="endPicker" formControlName="dateEnd" nzFormat="dd/MM/yyyy HH:mm"
          [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
        <span class="floating-text">{{langObj ? langObj?.EndDate : ('End Date' | translate)}}</span>
      </div>
      <div class="btn-position">
        <button type="submit" class="icon-btn" matTooltipClass="custom-tooltip" matTooltip="Apply Filter"
          (click)="onSubmit()" tooltipPosition="top">
          <img src="assets/images/search.png" alt="" width="20px" height="20px">
        </button>
      </div>
      <div class="d-flex" style="margin: 10px;">
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="today();showPhase(1)" [class.phase-active]="activeButton === 1"
            matTooltipClass="custom-tooltip" matTooltip="Today(Current Shift)">T</p>
        </div>
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="yesterday();showPhase(2)" [class.phase-active]="activeButton === 2"
            matTooltipClass="custom-tooltip" matTooltip="Yesterday(Last Shift)">1D</p>
        </div>
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="lastWeek();showPhase(3)" [class.phase-active]="activeButton === 3"
            matTooltipClass="custom-tooltip" matTooltip="Last Week">1W</p>
        </div>
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="lastMonth();showPhase(4)" [class.phase-active]="activeButton === 4"
            matTooltipClass="custom-tooltip" matTooltip="Last Month">1M</p>
        </div>
      </div>
    </div>
    <div class="chart-group">
      <div class="chart-items-w33">
        <div class="chart-title">{{langObj ? langObj?.DowntimeByCategory : ('Downtime By Category' | translate)}}</div>
        <div [chart]="chartDTClassificationParetoAnalysis"></div>
      </div>

      <div class="chart-items-w33">
        <div class="chart-title">{{langObj ? langObj?.DowntimeByClassification : ('Downtime By Classification' |
          translate)}}
        </div>
        <div [chart]="chartDTEquipmentParetoAnalysisReason1"></div>
      </div>
      <!-- <div class="chart-items-w33">
          <div class="chart-title">Downtime By Equipment
          </div>
          <div [chart]="chartDTEquipmentParetoAnalysisReason2"></div>
      </div> -->
    </div>
    <div class="chart-group">
      <!-- <div class="chart-items">
          <div class="chart-title">Downtime Reason Pareto Analysis Reason-4
          </div>
          <div [chart]="chartDTEquipmentParetoAnalysisReason4"></div>
      </div> -->
      <!-- <div class="chart-items-w33">
          <div class="chart-title">Downtime By Reason
          </div>
          <div [chart]="chartDTEquipmentParetoAnalysisReason3"></div>
      </div>-->
      <div class="chart-items-w66">
        <div class="chart-title">{{langObj ? langObj?.DowntimeByFault : ('Downtime By Fault' | translate)}}
        </div>
        <div [chart]="chartDTEquipmentParetoAnalysisFault"></div>
      </div>
    </div>
  </form>
  <div style="margin-top: 10px;">
    <ag-grid-angular style="width: 100%; height:30vw;" class="ag-theme-alpine" [columnDefs]="ColumnDefs"
      [rowData]="rowData" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)" [pagination]="true"
      [paginationPageSize]="paginationPageSize"></ag-grid-angular>
  </div>
</div>